
import { create } from "zustand"


const useProjectPrev = create((set) => ({
  active: false,
  id: null,
  onActive: (id) => set({ active: true, id: id }),
  resetId: () => set({ id: null }),
  filterId: '',
  onFilter: (filter) => set({ filterId: filter }),
  layout: /* localStorage.getItem("layout") || */ "grid2", // Get from localStorage or default to 'list'

  setInitialLayout: (pathname) => {
    const initialLayout = pathname === ("/" || "" )
      ? "grid2"
      : localStorage.getItem("layout") || "grid2"
    set({ layout: initialLayout });
  },

  setLayout: (type) => set({ layout: type }),

  toList: () => set(() => {
    localStorage.setItem("layout", "list");
    return { layout: "list" };
  }),

  toGrid: () => set(() => {
    localStorage.setItem("layout", "grid");
    return { layout: "grid" };
  }),

  toGrid2: () => set(() => {
    localStorage.setItem("layout", "grid2");
    return { layout: "grid2" };
  }),
  thisCurrentProject: (pr) => set({ id: pr.clientName, pr: pr }),
  sortedBy: "name",
  sortBy: (option) => set({ sortedBy: option }),

}))

export default useProjectPrev